// Site (map pin) types — the server's SITE_TYPES — with the pin colour and
// short code used on the map and in lists.
export const SITE_TYPES = {
  jobsite: { label: 'Jobsite', code: 'J', color: '#f5f7fa' },
  construction_site: { label: 'Construction site', code: 'C', color: '#f0883e' },
  factory: { label: 'Factory', code: 'F', color: '#e66767' },
  warehouse: { label: 'Warehouse', code: 'W', color: '#58a6ff' },
  distribution_center: { label: 'Distribution center', code: 'DC', color: '#a371f7' },
  supplier: { label: 'Supplier', code: 'S', color: '#3fb950' },
  port: { label: 'Port', code: 'P', color: '#39c5cf' },
  rail_terminal: { label: 'Rail terminal', code: 'R', color: '#d29922' },
  customer: { label: 'Customer destination', code: 'CU', color: '#db61a2' },
  other: { label: 'Other', code: '•', color: '#8b949e' },
};
export const SITE_STATUSES = ['active', 'planned', 'inactive', 'closed'];
export const typeStyle = (t) => SITE_TYPES[t] ?? SITE_TYPES.other;
